import NotifyActions from './NotifyActions'

/**
 * Makes an Action function with the following behavior:
 * @param method the name of the api method to invoke
 * @param type the resulting type of the dispatch message on a successful api call
 * @param resultKey either a string (the location in the resulting message to put
 *                  the api result in) or a function( msg, result, args ). msg is
 *                  is the msg to dispatch, the result is the api response and args
 *                  are the arguments used to invoke the method). If a method, it 
 *                  should populate the msg with the appropriate values from result
 * @param error Either a string ( error msg ), a function( ex, args ), or an object
 *              containing { 
 *                   msg : 'error msg', 
 *                   warning : [true|false], 
 *                   callback : function( ex, dispatch, getState, api, args, opts )
 *              }
 **/
function make( method, type, resultKey, error, onDone ) {
  return function() { 
    const args = arguments
    return function( dispatch, getState, api ) {
      invoke( api, method ).apply( api, args )
        .then( ( result ) => {
          const msg = { type }
          if ( typeof resultKey === 'string' ) {
            msg[resultKey] = result
            dispatch( msg )
          } else if ( typeof resultKey === 'function' ) {
            if ( resultKey( msg, result, args, dispatch, getState, api ) !== false ) {
              dispatch( msg )
            }
          } else { 
            dispatch( msg )
          }
          if ( onDone ) {
            onDone.apply( null, [].concat( [ null, result ], toArray( args ) ) )
          }
        } )
        .catch( ( ex ) => {

          if ( typeof error === 'function' ) {
            error( ex, args )
          } else if ( typeof error === 'string' ) {
            dispatch( NotifyActions.requestError( error, ex ) )
          } else if ( error ) {
            const opt = error
            dispatch( NotifyActions.requestError( opt.msg, ex, opt.warning ) )
            if ( typeof opt.callback === 'function' ) {
              opt.callback( ex, dispatch, getState, api, args, opt )
            }
          }
          if ( onDone ) {
            onDone.apply( null, [].concat( [ ex, null ], toArray( args ) ) )
          }
        } )  
    }
  }
}

function invoke( api, method ) {
  if ( typeof method === 'string' ) {
    return api[method]
  }

  if ( Array.isArray( method ) ) {
    let r = api
    for ( let n = 0; n < method.length; n++ ) {
      r = getFinalCall( r, method[n] )
    }
    return r
  } if ( method != null && typeof method === 'object' ) {
    return api[method.method].apply( api, method.args )
  }
  return null
}

function make2( method, type, resultKey, error, onDone ) {

}

function toArray( args ) {
  const rtn = new Array( args.length );
  for ( let i = 0; i < rtn.length; ++i ) {
    rtn[i] = args[i];
  }
  return rtn;
}

module.exports = {
  make
}
